import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import ClipCard from "@/components/feature/ClipCard";
import { clips } from "@/mocks/clips";

export default function LatestClips() {
  const latest = [...clips].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 6);

  return (
    <section className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16" id="latest">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          eyebrow="最新归档"
          title="刚刚整理完的爆料片段"
          description="每一段都标注了时间点、关键发言与弹幕摘录，点开即可回看现场。"
        />
        <Link
          to="/clips"
          className="mb-8 inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-label text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 md:mb-12"
        >
          查看全部片段
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((clip) => (
          <ClipCard key={clip.id} clip={clip} />
        ))}
      </div>
    </section>
  );
}